export enum ClaimPageOrder {
  Details = 0,
  Questionnaire = 1,
  Documents = 2,
  Review = 3
}
